export type GwSection = "summary" | "findings" | "checksheet" | "user-reconcile" | "history" | "schedule" | "connect";
export interface SectionTab { readonly section: GwSection; readonly label: string; }
export const SECTION_TABS: readonly SectionTab[] = [
  { section: "summary", label: "サマリ" },
  { section: "findings", label: "検出" },
  { section: "checksheet", label: "チェックシート" },
  { section: "user-reconcile", label: "ユーザー棚卸し" },
  { section: "history", label: "実行履歴" },
  { section: "schedule", label: "スケジュール" },
  { section: "connect", label: "接続" },
];
export const GW_SECTIONS: readonly GwSection[] = SECTION_TABS.map((t) => t.section);

// AI アシスタント右パネルを文脈付きで開くための型（検出からの「AIに相談」等）。
export interface AssistantContext {
  readonly title: string;
  readonly prompt: string;
}
